import React, { useContext, useState } from "react";
import { OrdersContext } from "../context/orders.context";
import { processType } from "../utils/constant";
import moment from "moment/moment";
import { useNavigate, Link } from "react-router-dom";
import ChatButton from "./Chat/ChatButton";
import { ChatRefContext } from "../context/chatRef.context";
import Chat from "./Chat";
import qs from "query-string";
import { convertAdminPriceToCustomer, currencyFormatter } from "../utils/helper";

const OfferTable = ({ rFQData }) => {
  console.log("rFQData", rFQData);
  const { activeTab } = useContext(OrdersContext);
  const { selectedChatRefId, setSelectedChatRefId } =
    useContext(ChatRefContext);

  const { search } = window.location;
  const param = qs.parse(search);
  const [open, setOpen] = useState(param.RefId);
  const navigate = useNavigate();

  const showDrawer = (id) => {
    setOpen(id);
    setSelectedChatRefId(id);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedChatRefId(null);
  };

  const showPricingAccordingToCurrency = (price,item) => {
    //convert the price
    console.log('Selected rfq ::', item);
    const { currencySnapshot } = item || {};
    const customerRate = currencySnapshot?.customerRate;
    const convertedPrice = convertAdminPriceToCustomer(price, customerRate);
    console.log('Converted price ::', convertedPrice);
    return currencyFormatter(convertedPrice);
  }



  return (
    <div className="relative overflow-x-auto w-full">
      <Chat
        RefId={selectedChatRefId}
        open={selectedChatRefId === open && selectedChatRefId?.length > 0}
        onDrawerClose={onClose}
      />

      <table className="w-full table-auto text-sm text-left rtl:text-right text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 w-full">
          <tr>
            <th scope="col" className="px-6 py-2">Offer ID</th>
            <th scope="col" className="px-6 py-2">PROJECT NAME</th>
            <th scope="col" className="px-6 py-2">TYPE OF MFG. PROCESS</th>

            {/* centered columns */}
            <th scope="col" className="px-6 py-2 text-center">NO. OF COMPONENTS</th>
            <th scope="col" className="px-6 py-2 text-center">STATUS</th>
            {activeTab != "pending-for-quotation" ? (
              <th scope="col" className="px-6 py-2 text-center">QUOTE VALUE</th>
            ) : null}
            <th scope="col" className="px-6 py-2">REQUEST DATE</th>
            <th scope="col" className="px-6 py-2 text-center">CHAT</th>
          </tr>
        </thead>

        <tbody className="rfq-body">
          {rFQData.length > 0 &&
            rFQData.map((item, i) => (
              <tr key={i} className="bg-white border-b">
                <td scope="col" className="px-6 py-2 text-xs font-medium underline cursor-pointer">
                  <Link className="text-primaryColor" to={`/offer-details/${item?._id}`}>{item?.supplierRFQRefId}</Link>
                </td>

                <td scope="col" className="px-6 py-2 !text-xs">{item?.rfqOfferId?.projectName}</td>
                <td scope="col" className="px-6 py-2">
                  {processType[item?.rfqOfferId?.selectedProcess - 1]?.name}
                </td>

                {/* center numeric */}
                <td className="px-6 py-2 text-center">{item?.partsData?.length}</td>

                {/* center status */}
                <td className={`px-6 py-2 text-center flex items-center justify-center ${activeTab}`}>
                  {item?.rfqOfferId?.rfqOfferStatus === "offer accepted"
                    ? "Offer Accepted"
                    : item?.rfqOfferId?.rfqOfferStatus === "cancelled-offer"
                      ? "Decline Offer"
                      : item.status}
                </td>

                {/* center currency if shown */}
                {activeTab != "pending-for-quotation" ? (
                  <td className="px-6 py-2 text-center">
                    {showPricingAccordingToCurrency(Number(item?.offerPrice),item)}
                  </td>
                ) : null}

                <td className="px-6 py-2">{moment(item.receivedDate).format("DD MMM YYYY")}</td>

                {/* center chat */}
                <td className="px-6 py-1 text-center">
                  <button
                    className="bg-primaryColor rounded inline-flex items-center justify-center"
                    onClick={() => showDrawer(item.supplierRFQRefId)}
                  > 
                    <ChatButton
                      RefId={item.supplierRFQRefId}
                      showDrawer={() => showDrawer(item.supplierRFQRefId)}
                      color="white"
                      additionalClasses="text-white text-sm h-8"
                    />
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {rFQData.length == 0 ? (
        <div style={{ textAlign: "center", fontSize: "14px", width: "100%", marginTop: "5px" }}>
          No Data Found
        </div>
      ) : null}
    </div>

  );
};

export default OfferTable;
